module.exports = __webpack_public_path__ + "img/bgicon.b3450583.png";